import { toExcel } from '../Funciones'
import React,{useState,useEffect} from 'react'
import axios from 'axios'
import { format,parse } from 'date-fns'
import flecha from '../Img/flecha.png'
import AddRegistro from './AddRegistro'
import EditRegistro from './EditRegistro'
export default function Registros({usuario}){
    const columnas=usuario.administrador?["Cliente","Centro","Proyecto","Usuario","Inicio","Fin","Descripción","Observaciones","Duración(h)"]:["Cliente","Centro","Proyecto","Inicio","Fin","Descripción","Observaciones","Duración(h)"]
    const [showCheckbox, setShowCheckbox] = useState(null);
    const[registros,setRegistros]=useState([])
    const[clientes,setClientes]=useState([])
    const[centros,setCentros]=useState([])
    const[proyectos,setProyectos]=useState([])
    const[usuarios,setUsuarios]=useState([])
    const [begin,setBegin]=useState(parse("01/01/2000","dd/MM/yyyy",new Date()))
    const [end,setEnd]=useState(parse(formatString(new Date()),"dd/MM/yyyy",new Date()))
    const[accion,setAccion]=useState("")
    const valores=usuario.administrador?[clientes,centros,proyectos,usuarios]:[clientes,centros,proyectos]
    const [ids_clientes,setIdsClientes]=useState([])
    const [ids_centros,setIdsCentros]=useState([])
    const [ids_proyectos,setIdsProyectos]=useState([])
    const [ids_usuarios,setIdsUsuarios]=useState([])
    const [registro,setRegistro]=useState(null)
    let ids=[ids_clientes,ids_centros,ids_proyectos,ids_usuarios]
    const sets=[setIdsClientes,setIdsCentros,setIdsProyectos,setIdsUsuarios]
    const [terminados,setTerminados]=useState(true)
    const [no_terminados,setNoTerminados]=useState(true)
    function intervalo(str_inicio,str_fin){
        const formato = 'dd/MM/yyyy HH:mm:ss'
        const inicio=parse(str_inicio,formato,new Date())
        const fin=parse(str_fin,formato,new Date())
        return Math.round((fin-inicio)/(36000))/100
    }
    function formatStringReverse(str){
        const formato = 'dd/MM/yyyy HH:mm:ss'
        const d=new Date(parse(str,formato,new Date()))
        const dia = d.getDate().toString().padStart(2, '0');
        const mes = (d.getMonth() + 1).toString().padStart(2, '0');
        const año = d.getFullYear();
        const hora=d.getHours()
        const min=d.getMinutes()
        const sec=d.getSeconds()
        return `${año}/${mes}/${dia} ${hora}:${min}:${sec}`
    }
    function formatString(date){
        const d = new Date(date)
        const dia = d.getDate().toString().padStart(2, '0');
        const mes = (d.getMonth() + 1).toString().padStart(2, '0');
        const año = d.getFullYear();
        return `${dia}/${mes}/${año}`;
    }
    function dentro_de_intervalo(str_inicio,str_fin){
        const formato = 'dd/MM/yyyy'
        return parse(str_inicio.split(" ")[0],formato,new Date())>=parse(begin.getDate()+"/"+(begin.getMonth()+1)+"/"+begin.getFullYear(),formato,new Date()) && parse(formatString(end),'dd/MM/yyyy',new Date())>=parse(str_inicio.split(" ")[0],formato,new Date()) && (str_fin==null || parse(formatString(end),'dd/MM/yyyy',new Date())>=parse(str_fin.split(" ")[0],formato,new Date()))
    }
    useEffect(()=>{
        let clientesOrdenados=[]
        let centrosOrdenados=[]
        axios.get("https://www.asinova.es/webapi/api/Registros/ccpu")
            .then(res=>{setRegistros(res.data.sort((x,y)=>formatStringReverse(y.inicio).localeCompare(formatStringReverse(x.inicio))))})
        axios.get("https://www.asinova.es/webapi/api/Clientes/abierto-cerrado")
            .then(res=>{
                clientesOrdenados = res.data.sort((x, y) => x.nombre.localeCompare(y.nombre))
                setClientes(clientesOrdenados)
                setIdsClientes(clientesOrdenados.map(x=>x.id))
                return axios.get("https://www.asinova.es/webapi/api/Centros/abierto-cerrado")})
            .then(res=>{
                centrosOrdenados = res.data.sort((x,y)=>x.nombre.localeCompare(y.nombre)).sort((x, y) => clientesOrdenados.find(cliente=>cliente.id==x.id_cliente).nombre.localeCompare(clientesOrdenados.find(cliente=>cliente.id==y.id_cliente).nombre))
                setCentros(centrosOrdenados)
                setIdsCentros(centrosOrdenados.map(x=>x.id))
                return axios.get("https://www.asinova.es/webapi/api/Proyectos/abierto-cerrado")})
            .then(res=>{
                const proyectosOrdenados=res.data.sort((x,y)=>x.nombre.localeCompare(y.nombre)).sort((x,y)=>centrosOrdenados.find(centro=>centro.id==x.id_centro).nombre.localeCompare(centrosOrdenados.find(centro=>centro.id==y.id_centro).nombre)).sort((x,y)=>clientesOrdenados.find(cliente=>cliente.id==centrosOrdenados.find(c=>c.id==x.id_centro).id_cliente).nombre.localeCompare(clientesOrdenados.find(cliente=>cliente.id==centrosOrdenados.find(c=>c.id==y.id_centro).id_cliente).nombre))
                setProyectos(proyectosOrdenados)
                setIdsProyectos(proyectosOrdenados.map(x=>x.id))})
        axios.get("https://www.asinova.es/webapi/api/Usuarios/sin-perfil/abierto-cerrado")
            .then(res=>{
                setUsuarios(res.data.sort((x,y)=>x.nick.localeCompare(y.nick)))
                setIdsUsuarios(res.data.sort((x,y)=>x.nick.localeCompare(y.nick)).map(x=>x.id))})
    },[])
    const ChangeBegin=(event)=>{
        const valores=event.target.value.split("-")
        if (event.target.value.length==0 || valores[0].length>4){
            setBegin(parse("2000-01-01","yyyy-MM-dd",new Date()))
        }
        else{
            setBegin(parse(event.target.value,"yyyy-MM-dd",new Date()))
            if (parse(event.target.value,"yyyy-MM-dd",new Date())>end){
                setEnd(parse(event.target.value,"yyyy-MM-dd",new Date()))
            }
        }
    }
    const ChangeEnd=(event)=>{
        const valores=event.target.value.split("-")
        if (event.target.value.length==0 || valores[0].length>4){
            setEnd(new Date())
        }
        else{
            setEnd(parse(event.target.value,"yyyy-MM-dd",new Date()))
            if (parse(event.target.value,"yyyy-MM-dd",new Date())<begin){
                setBegin(parse(event.target.value,"yyyy-MM-dd",new Date()))
            }
        }
    }
    function comprobar(nuevaLista,index){
        if ((usuario.administrador && index<valores.length-2) || (!usuario.administrador && index<valores.length-1)){
            const nl=[...ids[index+1]]
            switch (index){
                case 0:
                    const nl2=[...ids_proyectos]
                    for (let i=0; i<centros.length; i++){
                        nl[i]=nuevaLista.includes(centros[i].id_cliente)?centros[i].id:'no'
                        for (let j=0; j<proyectos.length; j++){
                            nl2[j]=nl.includes(proyectos[j].id_centro)?proyectos[j].id:'no'
                            setIdsProyectos(nl2)
                        }
                    }
                    break;
                case 1:
                    for (let i=0; i<proyectos.length; i++){
                        nl[i]=nuevaLista.includes(proyectos[i].id_centro)?proyectos[i].id:'no'
                    }
                default:
                    break;
            }
            sets[index+1](nl)
        }
    }
    const CheckboxChange = (index, id, checked) => {
        const nuevaLista = [...ids[index]]
        nuevaLista[valores[index].findIndex(x => x.id === id)] = checked ? id : ""
        sets[index](nuevaLista)
        comprobar(nuevaLista,index)
    }
    const invertir=(index)=>{
        const nuevaLista = [...ids[index]]
        for (let i=0; i<nuevaLista.length; i++){
            if (nuevaLista[i]==""){
                nuevaLista[i]=valores[index][i].id
            }
            else if (nuevaLista[i]!="no"){
                nuevaLista[i]=""
            }
        }
        sets[index](nuevaLista)
        comprobar(nuevaLista,index)
    }
    const todos=(index)=>{
        const nuevaLista = [...ids[index]]
        for (let i=0; i<nuevaLista.length; i++){
            if (nuevaLista[i]==""){
                nuevaLista[i]=valores[index][i].id
            }
        }
        sets[index](nuevaLista)
        if ((usuario.administrador && index<valores.length-2) || (!usuario.administrador && index<valores.length-1)){
            comprobar(nuevaLista,index)
        }
    }
    const Limpiar=()=>{
        for (var j=0; j<sets.length; j++){
            sets[j](valores[j].map(x=>x.id))
        }
        parse("01/01/2000","dd/MM/yyyy",new Date())
        parse(formatString(new Date()),"dd/MM/yyyy",new Date())
    }
    return(
        <>
        <h1 style={{textAlign:'center',margin:'1rem'}}>REGISTROS</h1>
        <div className="div-opciones-mini" style={{marginTop:'3rem'}}>
            <a className="btn-form" onClick={()=>setAccion(accion=="post"?"":"post")}>Añadir</a>
        </div>
        <a style={{position:'absolute',right:'0', marginRight:'1rem',fontSize:'0.8rem',marginTop:'1rem',padding:'0.5rem 0.8rem'}} className='btn-form' onClick={()=>toExcel(registros.filter(r=>dentro_de_intervalo(r.inicio,r.fin) && clientes.find(x=>x.nombre==r.cliente && ids_clientes.includes(x.id))!=null && centros.find(x=>x.nombre==r.centro && ids_centros.includes(x.id))!=null && proyectos.find(x=>x.nombre==r.proyecto && ids_proyectos.includes(x.id))!=null && ((usuario.administrador && usuarios.find(x=>x.nick==r.usuario && ids_usuarios.includes(x.id))!=null) || (!usuario.administrador && r.usuario==usuario.nick)) && ((terminados && r.fin!=null) || (no_terminados && r.fin==null))).map(
                    (r)=>(usuario.administrador?{
                        Cliente:r.cliente,
                        Centro:r.centro,
                        Proyecto:r.proyecto,
                        Usuario:r.usuario,
                        Inicio:r.inicio.replace(":"+r.inicio.split(":")[2],""),
                        Fin:r.fin==null?"No terminado":r.fin.replace(":"+r.fin.split(":")[2],""),
                        Descripción:r.descripcion,
                        Observaciones:r.observaciones,
                        "Duración(h)":r.fin==null?"En curso":intervalo(r.inicio,r.fin)}:
                        {
                        Cliente:r.cliente,
                        Centro:r.centro,
                        Proyecto:r.proyecto,
                        Inicio:r.inicio.replace(":"+r.inicio.split(":")[2],""),
                        Fin:r.fin==null?"No terminado":r.fin.replace(":"+r.fin.split(":")[2],""),
                            Descripción:r.descripcion,
                            Observaciones:r.observaciones,
                            "Duración(h)":r.fin==null?"En curso":intervalo(r.inicio,r.fin)}
                    )))}>Excel</a>
            <div>
                <div className='flex'>
                    <form className='flex mid'>
                        <p>Inicio</p>
                        <input type='date' name='inicio' value={format(begin,"yyyy-MM-dd")} onChange={ChangeBegin} style={{marginTop:0}}/>
                        <div className='flex column' style={{marginBottom:'1rem'}}>
                            <img src={flecha} style={{width:'30px',marginBottom:'1rem'}} className='pointer' onClick={()=>setEnd(begin)}/>
                            <img src={flecha} style={{width:'30px',transform:'rotate(180deg)'}} className='pointer' onClick={()=>setBegin(end)}/>
                        </div>
                        <input type='date' name='fin' value={format(end,"yyyy-MM-dd")} onChange={ChangeEnd} style={{marginTop:0}}/>
                        <p>Fin</p>
                    </form>
                </div>
                <div className='flex' style={{justifyContent:'center',width:'fit-content',margin:'0 auto'}}>
                    <div style={{margin:'0.5rem 1rem',width:'fit-content'}}>
                        <input type="checkbox" id={"terminados"} name={"terminados"} style={{margin:'0'}} checked={terminados} onChange={()=>{setTerminados(!terminados)}}/>
                        <label for={"terminados"} style={{margin:'0 0.5rem'}}>Terminados</label>
                    </div>
                    <div style={{margin:'0.5rem 1rem',width:'fit-content'}}>
                        <input type="checkbox" id={"noterminados"} name={"noterminados"} style={{margin:'0'}} checked={no_terminados} onChange={()=>{setNoTerminados(!no_terminados)}}/>
                        <label for={"noterminados"} style={{margin:'0 0.5rem'}}>En Curso</label>
                    </div>
                </div>
                <table style={{margin:'0rem auto 1rem auto',borderRadius:'5px'}}>
                    <tr>
                    {columnas.map((col,index)=>(
                        <th key={index} style={{padding:0,overflow:'visible',position:'relative'}}>
                            <p style={{margin:0,padding:'0.5rem 1.5rem',backgroundColor:(usuario.administrador && index<4 || !usuario.administrador && index<3) && ids[index].find(x=>x=="")!=null?'aqua':''}} onClick={()=>setShowCheckbox(i=>(i===index?null:index))}>{col}</p>
                            {showCheckbox === index && index<valores.length &&(
                            <div style={{width:'max-content',position:'absolute',top:'100%'}}>
                                {valores[index].map((x,i)=>(
                                ids[index][i]!=='no'?
                                <div className='flex mid'style={{padding:'0.5rem 0.5rem',borderTop:'1px solid black',borderLeft:'1px solid black',borderRight:'1px solid black',backgroundColor:'yellow'}}>
                                    <input type="checkbox" id={x.id} name={x.id} value={x.id} style={{margin:'0'}} checked={ids[index].includes(x.id)} onChange={(e)=>CheckboxChange(index,x.id,e.target.checked)}/>
                                    <label for={x.id} style={{margin:'0 0.5rem'}}>{index==3?x.nick:x.nombre}</label>
                                </div>
                                :null
                                ))}
                                <div style={{padding:'0.5rem 0.5rem',border:'1px solid white',backgroundColor:'#101218',color:'white',justifyContent:'space-between'}} className='flex'>
                                    <a onClick={()=>invertir(index)} className='btn-form' style={{fontSize:'0.8rem',padding:'0 0.5rem',marginRight:'1rem'}}>Invertir</a>
                                    <a onClick={()=>todos(index)} className='btn-form' style={{fontSize:'0.8rem',padding:'0 0.5rem',margin:0}}>Todos</a>
                                </div>
                            </div>
                            )}
                        </th>
                    ))}
                    </tr>
                    {registros.map(r=>(
                        dentro_de_intervalo(r.inicio,r.fin) && clientes.find(x=>x.nombre==r.cliente && ids_clientes.includes(x.id))!=null && centros.find(x=>x.nombre==r.centro && ids_centros.includes(x.id))!=null && proyectos.find(x=>x.nombre==r.proyecto && ids_proyectos.includes(x.id))!=null && ((usuario.administrador && usuarios.find(x=>x.nick==r.usuario && ids_usuarios.includes(x.id))!=null) || (!usuario.administrador && r.usuario==usuario.nick)) && ((terminados && r.fin!=null) || (no_terminados && r.fin==null))?
                        <>
                            <tr style={{cursor:'pointer'}} onClick={()=>{setRegistro(registro==null?r:null);setAccion(accion=="put-del"?"":"put-del")}} className={registro!=null && r.id==registro.id?'seleccion':r.fin==null?"en-curso":""}><td>{r.cliente}</td><td>{r.centro}</td><td>{r.proyecto}</td>{usuario.administrador?<td>{r.usuario}</td>:null}<td>{r.inicio.replace(":"+r.inicio.split(":")[2],"")}</td><td>{r.fin==null?"No terminado":r.fin.replace(":"+r.fin.split(":")[2],"")}</td><td style={{maxWidth:'150px'}}>{r.descripcion==null?"null":r.descripcion}</td><td style={{maxWidth:'150px'}}>{r.observaciones==null?"null":r.observaciones}</td><td>{r.fin==null?"En Curso":intervalo(r.inicio,r.fin)}</td></tr>
                        </>
                        :null
                    ))}
                </table>
                {accion!="" && (registro!=null || accion=="post")?
                    <div className="ventana-emergente">
                        <a className="btn-form" onClick={()=>{setRegistro(null);setAccion("")}} style={{padding:'0.1rem 0.45rem',marginTop:'1rem',float:'right'}}>X</a>
                            {accion=="post"?
                            <AddRegistro clientes={clientes} centros={centros} proyectos={proyectos.filter(x=>x.abierto)} registros={registros} usuarios={usuarios} user={usuario} setRegistros={setRegistros}/>:
                            accion=="put-del"?
                            <div className='flex' style={{marginRight:'3rem',marginTop:'1rem'}}>
                                <a className='btn-form' style={{marginRight:'1rem'}} onClick={()=>{setAccion("put")}}>Editar</a>
                                <a className='btn-form' onClick={()=>{
                                    axios.delete(`https://www.asinova.es/webapi/api/Registros/${registro.id}`)
                                        .then(()=>{
                                            setRegistros(registros.filter(r=>r.id!=registro.id));
                                            setAccion("");
                                            setRegistro(null);
                                        });
                                }}>Eliminar</a>
                            </div>:
                            accion=="put" && proyectos.find(x=>x.nombre==registro.proyecto && x.abierto)!=null && usuarios.find(x=>x.nick==registro.usuario && x.operativo)!=null?
                            <EditRegistro clientes={clientes} centros={centros} proyectos={proyectos.filter(x=>x.abierto)} registros={registros.filter(x=>proyectos.find(y=>y.nombre==x.proyecto && y.abierto)!=null && usuarios.find(y=>y.nick==x.usuario && y.operativo)!=null)} registro={registro} usuarios={usuarios} user={usuario} setRegistros={setRegistros}/>:
                            null
                            }                    
                    </div>
                    :null}
            </div>
        </>
    )
}